import { css } from 'styled-components';
import { ThemeMode } from '../../../enums/index.mjs';
import { px2rem } from '../../../helpers/rem.mjs';

var BG_LEVEL_BACKGROUND_CLASS_NAME = "bglevel-background";
var getBGLevelWithBackgroundStyle = function getBGLevelWithBackgroundStyle(styles, params) {
  return css(["position:sticky;background-color:", ";", ""], function (props) {
    return props.theme.colorV2.colorSet.white1000;
  }, function (props) {
    return props.theme.themeMode.mode === ThemeMode.DARK ? css(["&::before{", " content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none;", "}"], (params === null || params === void 0 ? void 0 : params.borderRadius) && css(["border-radius:", ";"], px2rem(params.borderRadius)), styles) : css(["", ""], styles);
  });
};

export { BG_LEVEL_BACKGROUND_CLASS_NAME, getBGLevelWithBackgroundStyle };
